
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import Loading from 'vue-loading-overlay';
import { APP_CONFIG } from '@/config/app-config';
import { DATA } from '@/config/data';
import creditServices from '@/services/credit-services';
import { eventBus } from '@/main';
const numeral = require('numeral');
@Component({
    components: {
        Loading
    }
})
export default class Recharge extends Vue {
  @Prop({ default: null })
  private onRecharge!: boolean;
  private bankInfo = {
      'name': '',
      'acc_number': '',
      'acc_name': ''
    }
  private bankInfos = [
    {
      'name': 'MBbank',
      'acc_number': '1230001688',
      'acc_name': 'Do Bui Ngoc Bich'
    },
    {
        'name': 'BIDV',
        'acc_number': '8805650627',
        'acc_name': 'Do Bui Ngoc Bich'
    }
  ]
  private isLoading = false;
  private rechargeModel = {
    rechargeValue: 0,
    bankId: 0,
    tradeContent: ''
  };
  get userInfo() {
    return this.$store.state[APP_CONFIG.stateKey.authStore].userInfo;
  }
  get rechargeMethods() {
    return DATA.rechargeMethods;
  }
  get qrLink() {
    return `https://api.vietqr.io/image/${this.bankInfo.name}-${this.bankInfo.acc_number}-K5pY8mL.jpg?addInfo=NHTD${this.userInfo.userId}&accountName=${this.bankInfo.acc_name}`;
  }
  @Watch('onRecharge', { immediate: true, deep: true })
  private watchOnRecharge() {
    this.recharge();
  }

  private async recharge() {
    try {
      const isValid = await (this.$refs['observer'] as any).validate();
      if (isValid) {

        this.isLoading = true;

        const dataRequest = {
          Amount: numeral(this.rechargeModel.rechargeValue).value(),
          Method: this.rechargeModel.bankId,
          UID: this.userInfo.userId,
          Username: this.userInfo.userName,
          TradeContent: this.rechargeModel.tradeContent
        };

        const result = await creditServices.submitRecharge(dataRequest);

        if (
          result &&
          result.status === 200 &&
          result.data.message === 'Success'
        ) {
          Vue.notify({
            group: 'foo',
            type: 'success',
            title: 'Thông báo!',
            text: 'Tạo lệnh nạp tiền thành công!',
          });
          this.rechargeModel = {
            rechargeValue: 0,
            bankId: 0,
            tradeContent: ''
          };
          eventBus.$emit(APP_CONFIG.eventBusAction.reloadWithdrawalHistories);
        } else {
          Vue.notify({
            group: 'foo',
            type: 'error',
            title: 'Thông báo!',
            text: 'Tạo lệnh nạp tiền thất bại!',
          });
        }
        this.isLoading = false;
      }
    } catch {
      return false;
    }
  }
}
